const vueVariantsClearancePane = new Vue({
    name: "vueVariantsClearancePane",
    el: "#clearance-pane", 
    data: {
        productId: GLOBAL.PRODUCT.ID
    },
    mixins: [
        requestServiceMixin,
        shoppingCartServiceMixin,
        variantsMixin,
        vatMixin
    ]
});